module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    on: {
      "click": _vm.fh
    }
  }), _vm._v(" "), _c('p', [_vm._v("搜索")])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ssgq),
      expression: "ssgq"
    }],
    staticClass: "ecss",
    attrs: {
      "type": "text",
      "placeholder": "歌手/歌名/拼音"
    },
    domProps: {
      "value": (_vm.ssgq)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ssgq = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "tss",
    attrs: {
      "href": "#/search/keywordSearch"
    },
    on: {
      "click": _vm.huoqu
    }
  }, [_vm._v("搜索")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e322c5f4"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/sheader.vue
// module id = 279
// module chunks = 0